<!-- 报警触发------综合触发器 -->
<template>
        <!-- 表格 -->
        <div class="main">
            <!-- 搜索区域 -->
            <div class="head">
                <div class="searchArea">
                    <div class="title">查询数据</div>
                    <div class="content">
                        <el-form style="width: 90%"  label-width="90px">
                            <el-row :gutter="24">
                            <el-col :span="12">
                                <el-form-item label="选择变量：">
                                <el-select v-model="searchParams.params" placeholder="请选择" size="small" clearable filterable>
                                    <el-option
                                    v-for="(item,index) in paramsList"
                                    :key="index"
                                    :label="item.name" :value="item.name"></el-option>
                                </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="触发条件：">
                                <el-select v-model="searchParams.condition" placeholder="请选择" size="small" clearable>
                                    <el-option
                                    v-for="(item,index) in triggerConditionList"
                                    :key="index"
                                    :label="item.value" :value="item.id"></el-option>
                                </el-select>
                                </el-form-item>
                            </el-col>
                            </el-row>
                            <el-row :gutter="24">
                            <el-col :span="12">
                                <el-form-item label="状态开关：">
                                <el-select v-model="searchParams.status" placeholder="请选择" size="small" clearable>
                                    <el-option
                                    v-for="(item,index) in statusList"
                                    :key="index"
                                    :label="item.label" :value="item.id"></el-option>
                                </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="推送机制：">
                                <el-select v-model="searchParams.mechanism" placeholder="请选择" size="small" clearable>
                                    <el-option
                                    v-for="(item,index) in mechanismList"
                                    :key="index"
                                    :label="item.label" :value="item.id"></el-option>
                                </el-select>
                                </el-form-item>
                            </el-col>
                            </el-row>
                        </el-form>
                        <div class="block"></div>
                        <div class="rightBtn">
                            <el-button type="primary" icon="el-icon-search" size="small" class="btnStyle" style="margin-bottom:0.1rem" @click="onSearch">查询</el-button>
                            <el-button icon="el-icon-refresh-left" size="small" style="margin-left: 0;" @click="resetting">重置</el-button>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 表格区域 -->
            <div class="tableArea">
                <!-- 操作区域 -->
                <div class="option">
                    <div>
                        <el-input placeholder="请输入触发器名称" v-model="searchParams.title" style="width: 5rem;" size="small" >
                            <i slot="prefix" class="el-input__icon el-icon-search"></i>
                            <el-button type="primary" slot="append" @click="onSearch">搜索</el-button>
                        </el-input>
                    </div>
                    <div>
                        <el-button type="primary" size="small" icon="el-icon-plus" class="btnStyle" @click="operation('add')">综合触发</el-button>
                        <el-button icon="el-icon-delete" size="small" @click="deletionByQuery">删除</el-button>
                    </div>
                </div>
                <div class="table">
                <el-table :data="tableData" style="width: 100%" row-key="id" :header-cell-style="{background:'#FAFAFA',color:'#405891'}" @selection-change="handleSelectionChange">
                    <el-table-column type="selection" width="55" reserve-selection></el-table-column>
                    <el-table-column label="序号" width="80">
                    <template slot-scope="scope">
                        {{scope.$index+1}}
                    </template>
                    </el-table-column>
                    <el-table-column prop="title" label="触发器名称" width="200">
                    </el-table-column>
                    <el-table-column prop="params" label="变量">
                    </el-table-column>
                    <el-table-column prop="condition" label="触发条件">
                        <template slot-scope="scope">
                           <span>{{getCondition(scope.row.condition)}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="设定值">
                        <template slot-scope="scope">
                           {{getSetValue(scope.row)}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="mechanism" label="推送机制">
                        <template slot-scope="scope">
                          <span>{{scope.row.mechanism == 1?'仅发一次':'间隔一定时间发送'}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="push" label="推送方式">
                        <template slot-scope="scope">
                          <span>{{scope.row.push == 1?'短信':(scope.row.push ==2?'邮件':'短信 ，邮件')}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="is_use" label="状态" >
                    <template slot-scope="scope" >
                        <el-switch active-value="1"  inactive-value="2" v-model="scope.row.is_use" active-color="#35C75C" inactive-color="#E9E9EB" @change="changeStatus($event,scope.row)">
                        </el-switch>
                    </template>
                    </el-table-column>
                    <el-table-column label="操作" width="150" fixed="right">
                    <template slot-scope="scope">
                        <el-button style="color:#437EDE" type="text" @click="operation('edit',scope.row)">编辑</el-button>
                        <el-button type="text"  @click="handleTop(scope.row,scope.$index)" :disabled="scope.$index==0">置顶</el-button>
                        <el-button style="color:#437EDE" type="text" @click="handleDelete(scope.row)">删除</el-button>
                    </template>
                    </el-table-column>
                </el-table>
                <div style="margin-top:0.2rem;text-align:right;">
                    <a-pagination v-model="current" show-quick-jumper show-size-changer :page-size-options="pageSizeOptions" :total="totalCount" @change="onChange" @showSizeChange="pageSizeChange"/>
                </div>
                </div>
            </div>
            <!-- 新增/编辑综合触发器弹框 -->
            <el-dialog :title="dialogTitle+'综合触发'" :visible.sync="dialogVisiable" width="50%" @close="onCancle">
                <el-form  label-width="120px" :model="addFormValue" :rules="rules" ref="addFormValue">
                <el-form-item label="触发器名称：" prop="title">
                    <el-input placeholder="请输入名称" size="small" v-model="addFormValue.title"></el-input>
                </el-form-item>
                <el-form-item label="选择变量：" prop="params">
                    <el-select v-model="addFormValue.params" placeholder="请选择变量" size="small">
                    <el-option
                        v-for="(item,index) in paramsList.slice(1)"
                        :key="index"
                        :label="item.name" :value="item.name"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="触发条件：" prop="condition">
                    <div style="display:flex">
                        <el-select v-model="addFormValue.condition" placeholder="请选择触发条件" size="small">
                            <el-option  v-for="(item,index) in triggerConditionList.slice(1)" :key="index"  :label="item.value" :value="item.id"></el-option>
                        </el-select>
                        <div style="margin-left:10px">
                            <el-input v-if="addFormValue.condition==1 ||addFormValue.condition==2||addFormValue.condition==3||addFormValue.condition==4"
                            placeholder="A=" size="small" v-model="addFormValue.A"></el-input>
                            <el-input v-if="addFormValue.condition==3 ||addFormValue.condition==4" placeholder="B=" size="small" v-model="addFormValue.B"></el-input>
                        </div>
                    </div>
                </el-form-item>
                <el-form-item label="推送机制：" prop="mechanism">
                    <div>变量值达到巅峰时</div>
                    <el-radio-group v-model="addFormValue.mechanism" type="vertical">
                        <el-radio :label="1">仅一次推送</el-radio>
                        <div style="display:flex;aligin-items:center">
                            <el-radio :label="2">报警沉默时间</el-radio>
                            <el-input v-if="addFormValue.mechanism ==2" v-model="addFormValue.interval" placeholder="请输入" size="small" style="width:1.5rem"></el-input>
                            <div style="margin-left:0.1rem" v-if="addFormValue.mechanism ==2"><el-popover
                            ref="popover"
                            popper-class="popperStyle"
                            placement="right"
                            title="报警沉默时间:"
                            width="300"
                            trigger="hover"
                            content="假设设备的采集更新频率为1小时，报警沉默时间设置的1分钟。第一次报警（8:00）触发，立即推送，第二次报警需要下一次轮询并且设备还是处于报警状态（9:01）。">
                            <el-button slot="reference" size="small" type="text" style="color:#93A6D2;font-size:0.14rem">分钟<i class="el-icon-question"></i></el-button>
                            </el-popover>
                            </div>
                        </div>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="选择联系人：" prop="contact_ids">
                    <el-select v-model="contactIds" placeholder="请选择联系人" size="small" multiple>
                    <el-option  v-for="(item,index) in contactList" :key="index"  :label="item.username" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="推送方式：" prop="push">
                    <div style="display:flex">
                        <el-checkbox-group v-model="pushList">
                            <el-checkbox :label="1">短信</el-checkbox>
                            <el-checkbox :label="2">邮件</el-checkbox>
                        </el-checkbox-group>
                        <div style="margin-left:40px;color:#93A6D2"><i class="el-icon-info"></i>最少选择一种联系方式</div>
                    </div>
                </el-form-item>
                <el-form-item label="推送内容：">
                    <el-input v-model="addFormValue.push_info" type="textarea" placeholder="请输入内容"></el-input>
                </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                <el-button @click="onCancle" size="small">取 消</el-button>
                <el-button type="primary" size="small" class="btnStyle" @click="addzhTrigger">保 存</el-button>
                </div>
            </el-dialog>
        </div>
</template>
<script>
import { getTriggerList, addTrigger, getDeviceParams, editTrigger, delTrigger } from '@/api/page/alarmTrigger.js'
import { getContactList } from '@/api/page/contactList.js';
export default {
    data() {
        return {
            dialogTitle: "新增",
            // 搜索
            searchParams:{
               params:'全部',
               condition: 0,
               status: 0,
               mechanism: 0,
               title:'',
            },
            // 表格数据
            tableData:[],
            page: 1,
            limit: 10,
            totalCount: 500,
            current:1,
            selectedRows:[], // 选中的列表，用来批量删除
            dialogVisiable:false, //控制弹框显隐
            // 新增综合触发弹框数据
            addFormValue:{
                title:"",
                params: "",
                condition: "",
                A:"",
                B:"",
                mechanism: "",
                interval: "",
                contact_ids: "",
                push: "",
                push_info: ""
            },
            pushList:[],
            contactIds:[],
            // 变量
            paramsList:[],
            // 联系人列表
            contactList:[],
            rules: {
                title: [
                    { required: true, message: '请输入名称', trigger: 'blur' },
                ],
                params: [
                    { required: true, message: '请选择变量', trigger: 'change' },
                ],
                condition: [
                    { required: true, message: '请选择触发条件', trigger: 'change' },
                ],
                mechanism:[
                    { required: true, message: '请选择推送机制', trigger: 'change' },
                ],
                contact_ids:[
                    { required: true, message: '请选择联系人', trigger: 'change' },
                ],
                push:[
                    { required: true, message: '请选择推送方式', trigger: 'change' },
                ]
            },
            pageSizeOptions: ['10','20','30','40','50'],
        }
    },
    mounted() {
      this.getDeviceParams()
      this.getTriggerList()
      this.getContactList()
    },
    methods: {
    // 获取变量
    getDeviceParams() {
      let self = this;
      let data = {
        account: window.localStorage.getItem('account'),
        token: window.localStorage.getItem('token'),
        ts:this.stringTime(new Date())
      }
      getDeviceParams(data).then(res=> {
        self.paramsList = res.data
        self.paramsList.unshift({
            name: '全部',
        })
      })
    },
    // 获取触发器列表
    getTriggerList() {
        let self = this;
        let data = {
            account: window.localStorage.getItem('account'),
            type: 1,
            page: self.page,
            limit: self.limit,
            params: self.searchParams.params == '全部'? '': self.searchParams.params,
            condition: self.searchParams.condition,
            is_use: self.searchParams.status,
            mechanism: self.searchParams.mechanism,
            title: self.searchParams.title,
            token: window.localStorage.getItem('token'),
            ts:this.stringTime(new Date())
        }
        getTriggerList(data).then(res=> {
            self.tableData = res.data
            self.totalCount = res.meta.total_count

        })

    },
    // 获取联系人列表
    getContactList() {
      let data = {
        account: window.localStorage.getItem('account'),
        token: window.localStorage.getItem('token'),
        ts: this.stringTime(new Date())
      };
      getContactList(data).then(res=> {
        this.contactList = res.data
      })
      .catch((err)=> {
        console.log('error',err)
      })
    },
    getCondition(val) {
       let self = this;
       let condition = '';
       self.triggerConditionList.forEach(item=> {
         if(item.id == val) {
            condition = item.value
         }
       })
       return condition
    },
    // 触发器搜索
    onSearch() {
       this.page = 1
       this.limit = 10
       this.getTriggerList()
    },
    operation(type,val) {
       this.dialogVisiable = true;
       this.dialogTitle = (type== 'add'? '新增':'编辑')
       if(type=='edit'&&val) {
        this.$nextTick(()=> {
           this.addFormValue = Object.assign({},val)
           this.addFormValue.condition = Number(val.condition)
           let arr = JSON.parse(val.contact_ids)
           arr.forEach(i=> {
            this.contactIds.push(i.toString())
           })
           this.addFormValue.mechanism = Number(val.mechanism)
           if(val.push == '3') {
            this.pushList = [1,2]
           } else {
            this.pushList.push(Number(val.push))
           }
        })
       }
    },
    onCancle() {
        this.dialogVisiable = false
        this.contactIds = []
        this.pushList = []
        this.$refs['addFormValue'].resetFields();
    },
    // 新增综合触发
    addzhTrigger() {
      this.dialogVisiable = true
      let data = {
        account: window.localStorage.getItem('account'),
        token: window.localStorage.getItem('token'),
        type:1,
        is_use: 2,
        ts:this.stringTime(new Date())
      }
      let obj = Object.assign(data,this.addFormValue)
      this.$refs.addFormValue.validate((valid)=> {
        if(valid) {
            if(!this.addFormValue.A) {
                this.$message.warning('请输入A值')
                return
            }
            if(this.addFormValue.condition == 3 || this.addFormValue.condition == 4) {
                if(!this.addFormValue.B) {
                    this.$message.warning('请输入B值')
                    return
                }
            }
            if(this.addFormValue.mechanism ==2) {
                if(!this.addFormValue.interval) {
                    this.$message.warning('请输入报警沉默时间')
                    return
                }
            }
            if(this.dialogTitle == '新增') {
                addTrigger(obj).then(res=> {
                    if(res.data == 'success') {
                        this.$message.success('添加成功')
                        this.dialogVisiable = false;
                        this.getTriggerList()
                    }
                })
            } else {
                editTrigger(obj).then(res=> {
                     if(res.data == 'success') {
                        this.$message.success('编辑成功')
                        this.dialogVisiable = false;
                        this.getTriggerList()
                    }
                })
            }
        } else {
            return false
        }
      })
    },
    // 重置
    resetting() {
      this.searchParams = {
        params:'全部',
        condition: 0,
        status: 0,
        mechanism: 0,
      }
      this.getTriggerList()
    },
    // 置顶
    handleTop(row,index) {
        this.tableData.splice(index,1)
        this.tableData.unshift(row)
    },
    // 删除
    handleDelete(item) {
        let self = this;
        this.$confirm(`确定要删除${item.title}触发器吗？`,'提示',{
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(()=> {
            this.onDelete(item.id)
        }).catch(()=> {

        })
    },
    onDelete(id) {
      let data = {
          account: window.localStorage.getItem('account'),
          token: window.localStorage.getItem('token'),
          tid: id,
          ts: this.stringTime(new Date())
      }
      delTrigger(data).then(res=> {
        if(res.data == 'success') {
          this.$message({
            message:'删除成功',
            type: 'success'
          })
          this.getTriggerList()
        } else {
          this.$message({
            message:'删除失败，请重试',
            type: 'warning'
          })
        }
      })
    },
    // 选中的列表
    handleSelectionChange(val) {
      this.selectedRows = [];
      this.selectedRows = val;
    },
    // 批量删除
    deletionByQuery() {
      if(this.isNull(this.selectedRows)) {
        this.$message.warning('请选择需要删除的触发器')
        return
      }
      let arr = [];
      let ids = [];
      this.selectedRows.forEach(item=> {
        arr.push(item.title)
        ids.push(item.id)
      })
      this.$confirm(`确定要删除${arr.join(',')}吗？`,'提示',{
         confirmButtonText: '确定',
         cancelButtonText: '取消',
         type: 'warning'
      }).then(()=> {
        ids.forEach(j=> {
          this.onDelete(j)
        })
      }).catch(()=> {

      })
    },
    // 分页跳转
    onChange(val) {
      this.page = val
      this.getTriggerList()
    },
    pageSizeChange(page,pageSize) {
      this.page = page
      this.limit = pageSize
      this.getTriggerList()
    },
    getSetValue(item) {
        if(item.condition ==1 ||item.condition ==2) {
            let setValue = `A=${item.A}`
            return setValue
        } else {
            let setValue = `A=${item.A}  B=${item.B}`
            return setValue
        }
    },
    changeStatus(status,val) {
        let arr = JSON.parse(val.contact_ids)
        let contacts = []
        arr.forEach(i=> {
          contacts.push(i.toString())
        })
        val.contact_ids = contacts.join(',')
        let data = {
          type:1,
          account: window.localStorage.getItem('account'),
          token: window.localStorage.getItem('token'),
          ts: this.stringTime(new Date())
        }
        let obj = Object.assign(data,val)
        editTrigger(obj).then(res=> {
            if(res.data == 'success') {
            this.$message.success('修改成功')
            this.getTriggerList()
          }
        })
    }
  },
  watch:{
    pushList(val) {
      if(val.length ==1) {
        this.addFormValue.push = val[0]
      } else if (val.length ==2) {
        this.addFormValue.push = 3
      }
    },
    contactIds(val) {
       let arr = val.join(',')
       this.addFormValue.contact_ids = arr
    },
    "addFormValue.mechanism":{
        handler(val) {
            if(val == 2 && this.addFormValue.interval == 0) {
                this.addFormValue.interval = ""
            }
        }
    }
  },
  computed: {
    triggerConditionList(){
        return this.$store.state.triggerConditionList
    },
    statusList() {
        return this.$store.state.statusList
    },
    mechanismList() {
        return this.$store.state.mechanismList
    }
  }
}
</script>
<style scoped lang="less">
  // 搜索框
    .content ::v-deep .el-form-item {
        margin-bottom: 0.1rem;
        .el-form-item__label {
            color: #405891;
        }
    }
    ::v-deep .el-input-group__append, .el-input-group__prependtyle {
        background: #437ede;
        border-color: #437ede;
        color: #fff;
    }
    ::v-deep .el-radio {
        display:inline-block;
        margin-top: 10px;
    }
</style>
